namespace MACRAIL.Validation {

/**
 * Easy validation for form fields.
 */
export class PostcodeValidator implements IValidator {

    private opts: any;

    // tslint:disable-next-line:max-line-length
    private postCodeRegex = /^(((([A-PR-UWYZ][A-HK-Y]?[0-9][0-9]?)|(([A-PR-UWYZ][0-9][A-HJKSTUW])|([A-PR-UWYZ][A-HK-Y][0-9][ABEHMNPRV-Y]))) [0-9][ABD-HJLNP-UW-Z]{2}))$/i;

    // tslint:disable-next-line:max-line-length
    private postCodeShortRegex = /^(([A-PR-UWYZ][A-HK-Y]?[0-9][0-9]?)|(([A-PR-UWYZ][0-9][A-HJKSTUW])|([A-PR-UWYZ][A-HK-Y][0-9][ABEHMNPRV-Y])))$/i;

    // tslint:disable-next-line:max-line-length
    private eircodeRegex = /^([AC-FHKNPRTV-Y]{1}[0-9]{2}|D6W)[ ]?[0-9AC-FHKNPRTV-Y]{4}$/i;

    constructor (opts: any) {
        this.opts = opts;

        this.opts.allowShort = this.opts.allowShort || true;
    }

    public validate(value: any) {
        let opts = this.opts;

        if (value.length === 0) {
            return [];
        }

        let messages: IValidatorMessage[] = [];

        if (this.postCodeShortRegex.test(value)) {
            if (!this.opts.allowShort) {
                messages.push({
                    'slug': 'short',
                    'status': 'error',
                    'message': `Enter a full postcode.`,
                });
            }
        } else {
            if (!this.postCodeRegex.test(value)) {
                if (!this.eircodeRegex.test(value)) {
                    messages.push({
                        'slug': 'format',
                        'status': 'error',
                        'message': `Does not appear to be a valid postcode.`,
                    });
                }
            }
        }

        return messages;
    }
}

}
